import TrafficLightSystemTimesContainer from "./TrafficLightSystemTimesContainer";

export default TrafficLightSystemTimesContainer;